import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";


import UserService from "../services/user.service";


import { rejectedList } from "./listState";
const list = {
  list: [],
  pageSize: 25,
  page: 0,
  total: 0,
  nextPage: 0
};


//const users = {data: list, loading: false};


export const createUser = createAsyncThunk(
  "auth/createUser",
  async ( {user},thunkAPI) => {
    try {
      const data = await UserService.createUser(user);
      thunkAPI.dispatch(setMessage({message:"User created successfully", type:"success"}));
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({message:message, type:"error"}));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const updateUser = createAsyncThunk(
  "auth/updateUser",
  async ( {user},thunkAPI) => {
    try {
      const data = await UserService.updateUser(user);
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({message:message, type:"error"}));
      return thunkAPI.rejectWithValue();
    }
  }
);



export const getUsers = createAsyncThunk(
  "auth/get_users",
  async ({search}, thunkAPI) => {
    try {

      const data = await UserService.getUsers(search);
      return { users: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({message:message, type:"error"}));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getUser = createAsyncThunk(
  "auth/get_user",
  async ({username}, thunkAPI) => {
    try {
      const data = await UserService.getUser(username);
      return { users: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({message:message, type:"error"}));
      return thunkAPI.rejectWithValue();
    }
  }
);



// `data` is the paginated Users table. `lookups` is a username-keyed cache used by table
// cells (NiceUser) to resolve a display name. They are kept apart on purpose: single-user
// lookups used to push into `data.list` and bump `data.total`, which inflated the Users
// table's row count and injected rows that were never part of the requested page.
const initialState = {data: list, lookups: {}, loading: false}

const userSlice = createSlice({
  name: "users",
  initialState,
  extraReducers: {

    [getUsers.pending]: (state, action) => {
      state.loading = true;
    },
    [getUsers.fulfilled]: (state, action) => {
      state.data = action.payload.users;
      state.loading = false;
    },
    [getUsers.rejected]: (state, action) => {
      state.data = rejectedList(state.data, action);
      state.loading = false;
    },

    [createUser.fulfilled]: (state, action) => {
      // Add the new user to the list
      state.data.list.unshift(action.payload.data);
      state.data.total++;
    },

    [updateUser.fulfilled]: (state, action) => {
      const updated = action.payload.data;

      const matches = (user) =>
        !!user &&
        (user.id === updated.id ||
          user.username === updated.username ||
          user.userName === updated.userName);

      // Apply to the listed page and to every lookup-cache entry for this user, so the
      // detail page and any table cell showing them both reflect the edit.
      const targets = state.data.list.filter(matches);
      Object.keys(state.lookups).forEach((key) => {
        if (matches(state.lookups[key])) {
          targets.push(state.lookups[key]);
        }
      });

      targets.forEach((thisUser) => {
        if (updated.firstName !== undefined) {
          thisUser.firstName = updated.firstName;
        }
        if (updated.lastName !== undefined) {
          thisUser.lastName = updated.lastName;
        }
        if (updated.email !== undefined) {
          thisUser.email = updated.email;
        }
        if (updated.note !== undefined) {
          thisUser.note = updated.note;
        }
        // Handle both Avatar and avatar casing from API
        const newAvatar = updated.Avatar ?? updated.avatar;
        if (newAvatar !== undefined) {
          thisUser.Avatar = newAvatar;
          thisUser.avatar = newAvatar;
        }
        if (updated.active !== undefined) {
          thisUser.active = updated.active;
        }
        if (updated.userName !== undefined) {
          thisUser.userName = updated.userName;
        }
      });
    },

    // Single-user lookups are cell-level reads. They must not touch `data` (the Users
    // table's current page) nor `loading` (which the Users table reads) -- doing so made
    // the table blank itself and mis-report its total while cells resolved names.
    [getUser.fulfilled]: (state, action) => {
      const user = action.payload?.users;

      // Callers look users up by different handles: NiceUser asks by username, the user
      // detail scene asks by id (passed in the `username` argument). Index the result
      // under every handle we know so either lookup resolves.
      const keys = new Set();
      if (action.meta?.arg?.username) keys.add(action.meta.arg.username);
      if (user?.username) keys.add(user.username);
      if (user?.id) keys.add(user.id);

      keys.forEach((key) => {
        state.lookups[key] = user ?? null;
      });
    },
    [getUser.rejected]: (state, action) => {
      const username = action.meta?.arg?.username;

      // Remember the miss so the cell does not re-request it on every render.
      if (username && !action.meta?.aborted) {
        state.lookups[username] = null;
      }
    },


  },
});


const { reducer } = userSlice;
export default reducer;